function reputationLevelState(state) {
  return {
    levelValue: state.reputationLevel.levelValue,
    loading: state.reputationLevel.loading,
    recievedSuccessfulResponse: state.reputationLevel.recievedSuccessfulResponse,
    recievedErrorResponse: state.reputationLevel.recievedErrorResponse,
    levelComparison: state.reputationLevel.levelComparison
  };
}

export { reputationLevelState };
